import { setTerm } from './helpers';

export const setDealRent = setTerm('deal_rent');
